package uz.ferro.shop.model

import kotlinx.serialization.Serializable

@Serializable
data class Cart(
    var uuid: String? = null,
    val products: MutableList<CartProduct> = mutableListOf()
)